// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JGZyD","name":"styles_name__2JhMj","phone":"styles_phone__1_dWY"};